import { Reference } from '../../../../Api/references'

export function getFirstNodeLabel({
  accountDisplayName,
  ownDeclarationDomain,
  referencesFromPublisher,
}: {
  accountDisplayName: string
  ownDeclarationDomain?: string
  referencesFromPublisher: Reference[]
}): string {
  if (ownDeclarationDomain) {
    return ownDeclarationDomain
  }
  if (referencesFromPublisher.length) {
    const firstNode = referencesFromPublisher[0]
    return firstNode.name || firstNode.domain || accountDisplayName
  }
  return accountDisplayName
}
